import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AddCustomerDialogComponent } from '../../../components/customer/add-customer-dialog/add-customer-dialog.component';
import { CustomerTableViewComponent } from '../../../components/customer/customer-table-view/customer-table-view.component';
import { FilterCustomerDialogComponent } from '../../../components/customer/filter-customer-dialog/filter-customer-dialog.component';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { UIHelpers } from '../../../core/ui-helpers';
import { Customer } from '../../../models/customer/customer';
import { CustomerService } from '../../../models/customer/customerService';
import { Options } from '../../../components/ui/filterable-table/options';
import { TextInputComponent, TextModes } from '../../../components/ui/controls/text-input/text-input.component';
import { Page } from '../../../components/ui/filterable-table/tableViewAbstractComponent';
import { Textbox } from '../../../../../../../libs/Shared/components/inputs/textbox/textbox';
import { LoadingSpinnerComponent } from '../../../components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-terminal-customer',
  templateUrl: './terminal-customer.component.html',
  standalone: false,
})
export class TerminalCustomerComponent {
  @Input() merchantId: string | undefined;
  @Input() readonly: boolean = false;
  //@Input() selectedCustomer: Partial<Customer> | undefined;
  @ViewChild('txtSearchCustomers') txtSearchCustomers: Textbox | undefined;
  @ViewChild('customerTable') customerTableControl:
    | CustomerTableViewComponent
    | undefined;
  @Output() onCustomerChange = new EventEmitter<Partial<Customer>>();

  inputTextModes = TextModes;
  searchResults: Page<Partial<Customer>> = new Page<Partial<Customer>>({});

  selectedCustomer: Partial<Customer> | undefined;
  previousCustomer: Partial<Customer> | undefined;
  newCustomer: Partial<Customer> = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phone: '',
  };

  customerTableView: any;
  customerTableOptions: Options = new Options({
    selectAction: 'none',
    filterable: true,
    allowImpersonation: false,
  });

  addingCustomer: boolean = false;
  editingCustomer: boolean = false;
  searchingCustomers: boolean = false;
  allowCustomerChange: boolean = true;

  constructor(
    public customerService: CustomerService,
    public customerDialog: MatDialog,
    public addCustomerDialog: MatDialog,
    public loadingSpinnerDialog: MatDialog,
    public router: Router,
    private uiErrorHandler: UIErrorHandler,
    public uiHelper: UIHelpers,
  ) {
  }

  ngOnInit() {
    this.customerTableView = new TableView(CustomerTableViewComponent);
    this.customerTableOptions.merchantId = this.merchantId ?? '';
    this.customerTableOptions.debug = 'terminal-customer';

    // Testing...
    //this.btnSelectCustomer_click("518ca934-bde7-4064-8d0f-6f9053d4bec7");
  }

  public loadCustomer(customerId: string) {
    this.loadCustomerInfo(customerId, true);

    // also prevent change...
    this.allowCustomerChange = false;
  }

  public setCustomer(customer: Partial<Customer>) {
    this.selectedCustomer = customer;
    this.previousCustomer = undefined;
    this.searchingCustomers = false;
    this.addingCustomer = false;
    this.allowCustomerChange = false;
  }

  public clear() {
    this.selectedCustomer = undefined;
    this.previousCustomer = undefined;
    this.searchingCustomers = false;
    this.addingCustomer = false;
  }  


  txtSearchCustomers_keyup(searchTerm: string) {
    this.searchingCustomers = true;
    this.customerService.getPaged(searchTerm, {
      pageSize: 10,
      pageIndex: 0,
      merchantId: this.merchantId ?? '',
    }).then((customers) => {
      this.searchResults = customers;
    });
  }

  btnSelectCustomer_click(id: string) {
    this.loadCustomerInfo(id, true)
    .then(() => {
      this.searchingCustomers = false;
      this.addingCustomer = false;
      this.txtSearchCustomers?.clear();
    }); 
  }

  btnAcceptNewCustomer_click() {
    this.newCustomer.merchantId = this.merchantId ?? '';
    let loadingSpinnerRef = this.loadingSpinnerDialog.open(
      LoadingSpinnerComponent,
      {
        disableClose: true,
        panelClass: 'transparent-dialog',
        data: {
          mode: 'indeterminate',
        },
      },
    );
    //Create the new customer
    this.customerService.createCustomer(this.newCustomer).then((customer) => {
      this.selectedCustomer = customer;
      this.previousCustomer = undefined;
      this.addingCustomer = false;
      this.txtSearchCustomers?.clear();
      loadingSpinnerRef.close();
      this.onCustomerChange.emit(this.selectedCustomer);
    });
  }

  btnAddCustomer_click() {
    this.addingCustomer = true;
    this.searchingCustomers = false;
    //this.openAddCustomerResultsDialog();
  }

  btnCancelAddCustomer_click() {
    this.addingCustomer = false;
    this.selectedCustomer = undefined;
    this.onCustomerChange.emit(undefined);

  }

  btnChangeCustomer_click() {
    this.searchingCustomers = true;
  }

  formatPhone(val: string, ccCode: string) {
    return UIHelpers.formatPhone(val, ccCode);
  }

  async loadCustomerInfo(customerId: string, updateObservers: boolean): Promise<void> {
    return this.customerService
      .getCustomerById(customerId)
      .then((customer) => {
        this.selectedCustomer = customer;
        this.previousCustomer = undefined;

        if (updateObservers) {
          this.onCustomerChange.emit(this.selectedCustomer);
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }







  ////////////
// ORIGINAL CODE

  // handleTableInitialized() {
  //   this.customerTableControl?.setOptions(this.customerTableOptions);
  // }

  // btnSaveNewCustomer_click() {
  //   this.newCustomer.merchantId = this.merchantId;
  //   this.customerService.createCustomer(this.newCustomer).then((customer) => {
  //     if (customer.id) {
  //       this.btnSelectCustomer_click(customer.id);
  //     } else {
  //       this.uiErrorHandler.handleError('Failed to create customer');
  //     }
  //   });
  // }

  // handleCustomerSelected(customer: Partial<Customer>) {
  //   if (customer.id) {
  //     this.btnSelectCustomer_click(customer.id);
  //   } else {
  //     this.uiErrorHandler.handleError('Failed to load customer');
  //   }
  // }





  // // btnSelectCustomer_click() {
  // //   this.beginSelectCustomer();
  // // }

  // btnKeepCustomer_click() {
  //   this.selectedCustomer = this.previousCustomer;
  //   this.previousCustomer = undefined;
  // }




  // openCustomerResultsDialog(
  //   enterAnimationDuration: string,
  //   exitAnimationDuration: string,
  // ) {
  //   let ref = this.customerDialog.open(FilterCustomerDialogComponent, {
  //     width: '650px',
  //     disableClose: false,
  //     data: {
  //       merchantId: this.merchantId,
  //     },
  //   });

  //   this.router.events.subscribe(() => {
  //     ref.close();
  //   });

  //   ref.afterClosed().subscribe((customer) => {
  //     if (customer && customer.id) {
  //       this.loadCustomerInfo(customer.id, true);
  //     }
  //     this.searchingCustomers = false;
  //     this.addingCustomer = false;
  //   });
  // }

  // openAddCustomerResultsDialog() {
  //   let ref = this.addCustomerDialog.open(AddCustomerDialogComponent, {
  //     width: '500px',
  //     disableClose: false,
  //     data: {
  //       merchantId: this.merchantId,
  //     },
  //   });

  //   this.router.events.subscribe(() => {
  //     ref.close();
  //   });

  //   ref.afterClosed().subscribe((customer) => {
  //     this.selectedCustomer = customer;
  //     this.previousCustomer = undefined;
  //     this.searchingCustomers = false;
  //     this.addingCustomer = false;

  //     this.onCustomerChange.emit(this.selectedCustomer);
  //   });
  // }
}
